// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsandCondn {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: space-between;
  gap: 20px;
  height: 100dvh;
  text-align: center;
}
.TermsandCondn-content {
  margin: 13% 15px 0 15px;
  text-align: justify;
}
.TermsandCondn-content h1 {
  text-align: center;
  margin-bottom: 20px;
}
.TermsandCondn-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0px 50px 0px;
}
.TermsandCondn-btn {
  font-size: 14px;
  font-weight: 600;
  line-height: 25px;
  padding: 10px 20px;
}
.TermsandCondn-terms p {
  font-size: 15px;
  line-height: 28px;
  padding: 10px 0px;
  color: #414042;
}
.TermsandCondn-title-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.TermsandCondn-title-section {
  width: max-content;
  color: #414042;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.8rem;
  line-height: 2.625rem;
  margin-bottom: 20px;
  position: relative;
}
.TermsandCondn-title-section span:after {
  width: calc(100% + 6px);
  height: 1.6rem;
  background-color: #7dffd0;
  position: absolute;
  left: -3px;
  top: 12px;
  content: "";
  z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/Views/beforeAuth/Terms%20and%20Conditons/termsCondn.scss","webpack://./src/Views/beforeAuth/Terms and Conditons/termsCondn.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,0BAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;ACDJ;ADEI;EACI,uBAAA;EACA,mBAAA;ACAR;ADCQ;EACI,kBAAA;EACA,mBAAA;ACCZ;ADEI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;ACAR;ADEI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ACAR;ADEI;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAjCmB;ACiC3B;ADEI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;ACAR;ADEI;EACI,kBAAA;EACA,cA1CmB;EA2CnB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;ACAR;ADGI;EACI,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ACDR","sourcesContent":["$TermsandCondn-Font-Color: #414042; \n\n.TermsandCondn {\n    display: grid;\n    grid-template-columns: 1fr;\n    justify-content: space-between;\n    gap: 20px;\n    height: 100dvh;\n    text-align: center;\n    &-content {\n        margin: 13% 15px 0 15px;\n        text-align: justify;\n        h1 {\n            text-align: center;\n            margin-bottom: 20px;\n        }\n    }\n    &-btn-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 40px 0px 50px 0px;\n    }\n    &-btn {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 25px;\n        padding: 10px 20px;\n    }\n    &-terms p {\n        font-size: 15px;\n        line-height: 28px;\n        padding: 10px 0px;\n        color: $TermsandCondn-Font-Color;\n    }\n    &-title-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    &-title-section {\n        width: max-content;\n        color: $TermsandCondn-Font-Color;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 2.8rem;\n        line-height: 2.625rem;\n        margin-bottom: 20px;\n        position: relative;\n    }\n\n    &-title-section span:after {\n        width: calc(100% + 6px);\n        height: 1.6rem;\n        background-color: #7dffd0;\n        position: absolute;\n        left: -3px;\n        top: 12px;\n        content: '';\n        z-index: -1;\n    }\n}\n",".TermsandCondn {\n  display: grid;\n  grid-template-columns: 1fr;\n  justify-content: space-between;\n  gap: 20px;\n  height: 100dvh;\n  text-align: center;\n}\n.TermsandCondn-content {\n  margin: 13% 15px 0 15px;\n  text-align: justify;\n}\n.TermsandCondn-content h1 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n.TermsandCondn-btn-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 0px 50px 0px;\n}\n.TermsandCondn-btn {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 25px;\n  padding: 10px 20px;\n}\n.TermsandCondn-terms p {\n  font-size: 15px;\n  line-height: 28px;\n  padding: 10px 0px;\n  color: #414042;\n}\n.TermsandCondn-title-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.TermsandCondn-title-section {\n  width: max-content;\n  color: #414042;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 2.8rem;\n  line-height: 2.625rem;\n  margin-bottom: 20px;\n  position: relative;\n}\n.TermsandCondn-title-section span:after {\n  width: calc(100% + 6px);\n  height: 1.6rem;\n  background-color: #7dffd0;\n  position: absolute;\n  left: -3px;\n  top: 12px;\n  content: \"\";\n  z-index: -1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
